import { render, staticRenderFns } from "./school2.vue?vue&type=template&id=2f33e91a&scoped=true&"
import script from "./school2.vue?vue&type=script&lang=js&"
export * from "./school2.vue?vue&type=script&lang=js&"
import style0 from "./school2.vue?vue&type=style&index=0&id=2f33e91a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f33e91a",
  null
  
)

export default component.exports